import React, { Component } from 'react';
import fetchHelpers from '../../../helpers/fetchHelpers';
import Field from '../../../components/Field';
import validator from 'validator';
import graphql from '../../../helpers/graphql';

class Join extends Component {
  constructor (props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    let course = {};
    if (this.props.location.state && this.props.location.state.course) {
      course = {
        id: this.props.location.state.course.id
      };
    }
    this.state = {
      course: course,
      customer: { name: '', email: '', news: false },
      payment: { paymentOption: 'free', paymentType: 'free' },
      fieldErrors: {},
      serverError: '',
      isLoading: false
    };
  }

  onCheckboxChange (e) {
    const name = e.target.name;
    const value = e.target.checked;
    this.onInputChange(
      {
        name: name,
        value: value,
        error: null
      });
  }

  onInputChange (input) {
    let newState = this.state;
    newState.customer[input.name] = input.value;
    newState.fieldErrors[input.name] = input.error;
    this.setState(newState);
  }

  validate () {
    if (this.state.isLoading) return false;
    const fieldErrors = this.state.fieldErrors;
    const errMessages = Object.keys(fieldErrors).filter((k) => fieldErrors[k]);
    if (!this.state.customer.name) return false;
    if (!this.state.customer.email) return false;
    if (errMessages.length) return false;
    return true;
  }

  handleSubmit () {
    const newState = this.state;
    newState.isLoading = true;
    this.setState(this.state);
    var self = this;
    fetchHelpers.postToFreeTrial(this.state, function (data) {
      console.log(newState);
      if (data.status === 'success' && data.statusCode === 200) {
        // success
        if (newState.customer.news) {
          graphql.signupToMailingList(newState.customer).then(response => {
            if (response.mailingListMutation.success) {
              console.log('signup success');
              fetchHelpers.redirectToApp(data.token);
            }
          });
        } else {
          fetchHelpers.redirectToApp(data.token);
        }
      } else {
        // show validation / error message
        let newState = self.state;
        newState.serverError = data.message;
        newState.isLoading = false;
        newState.customer.token = data.token;
        self.setState(newState);
      }
    });
  }

  render () {
    return (
      <section className='hero registration-is-active'>
        <div className='l-container'>
          <div className='registration'>
            <div className='registration__step'>
              <div className='registration__inner'>
                <p className='kilo'>Get started absolutely free</p>
                <p className='error-message' style={{display: 'block', fontSize: '24px'}}>{this.state.serverError}</p>
                <ul className='form-fields'>
                  <li>
                    <label htmlFor='name' className='u-sr-only'>Name</label>
                    <Field
                      name='name'
                      type='text'
                      placeHolder='Fullname'
                      value={this.state.customer.name}
                      onChange={this.onInputChange}
                      validate={(val) => (val ? false : 'Name Required')}
                    />
                  </li>
                  <li>
                    <label htmlFor='email' className='u-sr-only'>Email</label>
                    <Field
                      name='email'
                      type='email'
                      placeHolder='Email'
                      value={this.state.customer.email}
                      onChange={this.onInputChange}
                      validate={(val) => (validator.isEmail(val) ? false : 'Invalid Email')}
                    />
                    <p className='label-extra' style={{marginTop: '.5rem'}}>We need this info so we can create your learning plan and save your progress</p>
                  </li>
                  <li>
                    <p className='label-extra'>By clicking on the 'Next' button below you agree to our <a href='https://s3-eu-west-1.amazonaws.com/static.bslcourses.co.uk/pdfs/bsl-terms.pdf' target='_blank' rel='noopener noreferrer'>Terms</a> and <a href='https://s3-eu-west-1.amazonaws.com/static.bslcourses.co.uk/pdfs/bsl-privacy.pdf' target='_blank' rel='noopener noreferrer'>Privacy Policy</a></p>
                    <p className='label-extra'>
                      <input
                        type='checkbox'
                        id='news'
                        name='news'
                        onChange={this.onCheckboxChange}
                        checked={this.state.customer.news} />
                        Tick this box if you would like to receive emails of discounted courses and any BSL news</p>
                  </li>
                </ul>
                <button
                  onClick={this.handleSubmit}
                  className={'registration__next button button--shadow button--l ' + (this.state.isLoading ? 'is-loading' : '')}
                  disabled={!this.validate()}>
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Join.propTypes = {
};

export default Join;



// WEBPACK FOOTER //
// ./src/views/Main/Join/index.js